import React, { useState } from "react";
import { endpoints } from "../utils/Constants";
import { eventGroupCode } from "../utils/Utils.js";

const TranslateWidget = ({ desc, cast, callback, isMobile }) => {
  const [loading, setLoading] = useState(false);
  const [translated, setTranslated] = useState(desc.contentAutoTranslated);
  const [originalDesc, setOriginalDesc] = useState(
    translated ? null : desc.description,
  );
  const [translatedDesc, setTranslatedDesc] = useState(
    !translated ? null : desc.description,
  );
  const [originalAdditional, setOriginalAdditional] = useState(
    translated ? null : desc.additionalText,
  );
  const [translatedAdditional, setTranslatedAdditional] = useState(
    !translated ? null : desc.additionalText,
  );
  const [originalCast, setOriginalCast] = useState(
    translated ? null : cast.contentText,
  );
  const [translatedCast, setTranslatedCast] = useState(
    !translated ? null : cast.contentText,
  );

  const getDescription = (translate) => {
    if (translate && translatedDesc) {
      callback(translatedDesc, translatedAdditional, translatedCast);
      setTranslated((prev) => !prev);
    } else if (!translate && originalDesc) {
      callback(originalDesc, originalAdditional, originalCast);
      setTranslated((prev) => !prev);
    } else {
      let lang = $("html").attr("lang");

      let url = endpoints.event.getDescription(
        eventGroupCode(),
        lang,
        translate,
      );

      setLoading(true);

      fetch(url, {
        method: "GET",
      })
        .then((res) => res.json())
        .then((data) => {
          if (translate) {
            setTranslatedDesc(data.description);
            setTranslatedAdditional(data.additionalText);
            setTranslatedCast(data.cast);
          } else {
            setOriginalDesc(data.description);
            setOriginalAdditional(data.additionalText);
            setOriginalCast(data.cast);
          }
          callback(data.description, data.additionalText, data.cast);
          setTranslated((prev) => !prev);
        })
        .catch((error) => {
          console.error(`Can't fetch translated description!`, error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const handleClick = () => {
    getDescription(!translated);
  };

  return (
    <div
      style={{
        width: "fit-content",
        display: "flex",
        alignItems: "center",
        padding: "8px 16px",
        borderRadius: 8,
        background: "#F7F3FF",
        gap: 12,
      }}
    >
      <div
        className="language-selector-ai-icn"
        style={{
          width: 18,
          height: 18,
          minWidth: 18,
        }}
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <span
          style={{
            color: "#000000",
            fontFamily: "pf_highway_sans_pro_lightRg",
            fontSize: isMobile ? 14 : 16,
            fontWeight: 400,
          }}
        >
          {translated
            ? playdetailsv2_resources.ContentAutoTranslated
            : playdetailsv2_resources.ContentOriginalLanguage}
          {isMobile && " "}
          <span
            onClick={loading ? undefined : handleClick}
            style={{
              color: "#0D0C1C",
              fontFamily: "pf_highway_sans_pro_mediumRg",
              fontSize: isMobile ? 14 : 16,
              fontWeight: 600,
              marginLeft: isMobile ? 0 : 8,
              textDecoration: "underline",
              cursor: loading ? "default" : "pointer",
              opacity: loading ? 0.5 : 1,
            }}
          >
            {translated
              ? playdetailsv2_resources.ShowOriginal
              : playdetailsv2_resources.TranslateAI}
          </span>
        </span>
      </div>
    </div>
  );
};

export default TranslateWidget;
